<template>
  <div class="procurementBidding wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-tree-table">
      <sliderTree :data="data" @handleNodeClick="handleNodeClick"></sliderTree>
      <div class="ccui-app-container">
        <div
          class="ccui-advanced-search-wrapper ccui-clearfix"
          v-if="!isShowDetail"
        >
          <div v-if="dicArr.length > 0">
            <div class="ccui-search-wrapper">
              <div class="ccui-tab-wrapper">
                <el-button type="table-top-active" size="mini">全部</el-button>
              </div>
            </div>
            <div class="dic-content">
              <ul>
                <li
                  class="detail-title"
                  v-for="(item, index) in dicArr"
                  :key="index"
                  @click="showDetail(item.faqId)"
                >
                  <span :title="item.faqName"
                    ><span class="doct">.</span>{{ item.faqName }}</span
                  >
                  <span>{{ item.time }}</span>
                </li>
              </ul>
            </div>
            <div class="table-footer" style="height:30px; margin-top:20px">
              <div class="ccui-table-footer">
                <div id="ccui-paging">
                  <el-pagination
                    :total="total"
                    :page-size="pageSizeCode"
                    :current-page="pageNoCode"
                    prev-text="< 上一页"
                    next-text="下一页 >"
                    background
                    :pagesize="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    popper-class="ccui-paging-page-size-popper"
                    @prev-click="handlePrev"
                    @next-click="handleNext"
                    @size-change="handleSizeChange"
                    @addCurrentPage="internalCurrentPage"
                    @current-change="handleCurrentChange"
                  />
                  <el-button
                    class="ccui-pagination-btn"
                    size="mini"
                    type="default"
                    @click="handleGoPage"
                    >确定</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="content-text" v-else>
            <!-- <img
              src="../../../assets/images/content_null.png"
              class="content-null-image"
              alt
            /> -->
            <p class="content-null-text">暂无相关数据</p>
          </div>
        </div>
        <div class="ccui-advanced-search-wrapper ccui-clearfix" v-else>
          <div class="dic-view">
            <div class="title-box">
              <span class="content-title" :title="faqProblemBO.title">
                {{ faqProblemBO.title }}
              </span>
            </div>
            <!--<div class="little-title">
              <span>来源： {{ faqProblemBO.publishTime }}</span>
              <span>作责 {{ faqProblemBO.readingCnt }}</span>
              <span>发布时间 {{ faqProblemBO.publishUser }}</span>
            </div>-->
            <el-divider></el-divider>
            <div class="content-detail" v-html="faqProblemBO.textContent"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import sliderTree from "@/app/shop/components/slideTree.vue";
import { queryNoviceGuide } from "@/app/shop/api/shopping";
export default {
  name: "procurementBidding",
  components: {
    baseBreadCrumb,
    sliderTree
  },
  data() {
    return {
      currBreadCrumb: [{ title: "采购招标" }, { title: "更多 >" }],
      data: [
        {
          label: "采购方操作指南",
          children: []
        }
      ],
      dicArr: [],
      isShowDetail: false,
      pageSizeCode: 20,
      pageNoCode: 1,
      total: 1000,
      pagesize: [10, 20, 50, 100, 200, 500],
      expendedIdArr: [69],
      faqProblemBO: {
        faqName: "11",
        publishTime: "11",
        readingCnt: "11",
        publishUser: "11",
        textContent: "11"
      }
    };
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      queryNoviceGuide({
        appUId: 100068
      }).then(res => {
        if (res.data.code === "0") {
          res.data.data.map(item => {
            item.label = item.title;
            return item;
          });
          this.$set(this.data[0], "children", res.data.data);
        }
      });
    },

    handleNodeClick(obj) {
      this.isShowDetail = true;
      this.faqProblemBO = obj;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    internalCurrentPage(val) {
      val = 10;
      console.log(`当前22页: ${val}`);
    },
    handlePrev() {},
    handleNext() {},
    handleGoPage() {
      console.log(111);
    },
    showDetail(id) {
      this.isShowDetail = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/config/styles/question-edit.scss";
/deep/ .el-tree-node__content {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

/* 改变被点击节点背景颜色，字体颜色 */
/deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: #f8f8f8 !important;
  color: #4a9de7 !important;
}
/*节点失焦时的背景颜色*/
/deep/
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #f8f8f8 !important;
  color: #4a9de7 !important;
}
// .ccui-tree-table .ccui-tree-wrapper /deep/ .el-tree-node__content span {
//   font-size: 14px;
//   font-weight: 600;
//   line-height: 20px;
//   height: 20px;
// }
/deep/ .el-tree-node > .el-tree-node__content {
  margin-bottom: 20px;
}
/deep/ .el-tree-node__children > .el-tree-node .el-tree-node__content {
  margin-bottom: 10px;
}
/deep/ .el-tree-node__children {
  transition: all 0.1s ease 0s;
}
/deep/ #ccui-paging .ccui-pagination-btn {
  display: block !important;
  margin-left: 5px;
  border-radius: 0;
}
/deep/ .detail-title {
  display: flex;
  justify-content: space-between;
  span:last-child {
    width: 82px;
    height: 20px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #999990;
    letter-spacing: 0;
    font-weight: 400;
  }
}
.ccui-tree-table .ccui-app-container {
  overflow: hidden;
}
</style>
